module.exports = __webpack_public_path__ + "static/media/Image3.dfa8c112.jpg";